import React from 'react';
export function PartnersSection() {
  const partners = ['Partner 1', 'Partner 2', 'Partner 3', 'Partner 4', 'Partner 5', 'Partner 6'];
  return <section className="bg-[#F5F5F5] py-16" data-id="element-212">
      <div className="max-w-7xl mx-auto px-4" data-id="element-213">
        <div className="text-center mb-12" data-id="element-214">
          <h2 className="text-2xl font-bold text-[#0B1F3A] mb-4" data-id="element-215">
            Trusted by Healthcare Providers
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center" data-id="element-216">
          {partners.map((partner, index) => <div key={index} className="bg-white rounded-lg shadow-sm p-6 flex items-center justify-center h-24 hover:shadow-md transition-shadow" data-id="element-217">
              <span className="text-gray-400 font-semibold text-center" data-id="element-218">
                {partner}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}